import LeaveSettings from "./LeaveSettings";
export default LeaveSettings;